var map = {
	"./author/form.vue": [
		"e79f",
		"chunk-7a8a3f6d"
	],
	"./member/form.vue": [
		"e7d1",
		"chunk-2d0e59f0",
		"chunk-48745142"
	],
	"./normal/form.vue": [
		"1243",
		"chunk-b0def0a0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "979d";
module.exports = webpackAsyncContext;